<template>
  <MultipleChoicesDropdown
    :title="title"
    :value="value"
    :show-clear-all="false"
    :single-choice="singleChoice"
    :search-enabled="true"
    :choices="choices"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import { getSectorChoices } from 'services/sectors'

export default {
  props: {
    value: { type: Array },
    title: { type: String, default: 'Sector' },
    singleChoice: { type: Boolean, default: false },
  },
  computed: {
    choices: getSectorChoices,
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
